// extracted by mini-css-extract-plugin
export var mainWrapper = "widgetCart-module--mainWrapper--fce05";